import React from 'react'

export default function HomeIcon({width, height, color}) {
  return (
    <svg width={width ? width : "20"} height={height ? height : "18"} viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0.111328L19.1895 9.31055L18.3105 10.1895L17.5 9.38867V17.25H11.25V11H8.75V17.25H2.5V9.38867L1.68945 10.1895L0.810547 9.31055L10 0.111328ZM16.25 16V8.13867L10 1.88867L3.75 8.13867V16H7.5V9.75H12.5V16H16.25Z" fill={color ? color : "#4F4A3E"}/>
    </svg>
  )
}
